module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/step4-pict01-d27f3fd7183ef51b00968d18c59e45c0.jpg";